import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone, FileText } from 'lucide-react';
import { Button } from '../ui/Button';
import { Logo } from './Logo';
import { useDrawers } from '../../contexts/DrawerContext';
import { cn } from '../../lib/utils';
const NAV_LINKS = [{
  label: 'Buying',
  href: '/buying-property'
}, {
  label: 'Selling',
  href: '/selling-property'
}, {
  label: 'Contract Review',
  href: '/contract-review'
}, {
  label: 'SMSF & Trusts',
  href: '/smsf-trust-property'
}, {
  label: 'Commercial Property',
  href: '/commercial-property'
}, {
  label: 'Resources',
  href: '/resources'
}, {
  label: 'About',
  href: '/about'
}];
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const {
    openQuote,
    openUpload
  } = useDrawers();
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);
  useEffect(() => {
    document.body.style.overflow = isMobileMenuOpen ? 'hidden' : 'unset';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMobileMenuOpen]);
  return <header className={cn('sticky top-0 left-0 right-0 z-40 transition-all duration-300 ease-soft border-b', isScrolled ? 'bg-background/90 backdrop-blur-xl border-border py-2.5 shadow-subtle' : 'bg-background border-border/70 py-3.5')} data-id="element-445" data-mp="3p11mhfd9i4fq">
      <div className="max-w-7xl mx-auto px-5 md:px-6 flex items-center justify-between" data-id="element-446" data-mp="19afgyyzknb0t">
        <Logo data-id="element-447" data-mp="1dbqx8dwk2jwc" />

        <nav className="hidden lg:flex items-center gap-7" aria-label="Primary" data-id="element-448" data-mp="1dbh9kwyzgott">
          <ul className="flex items-center gap-6" data-id="element-449" data-mp="3acdalawipvvp">
            {NAV_LINKS.map(link => <li key={link.label} data-id="element-450" data-mp="3ae7x2tnftw1w">
                <Link to={link.href} className="text-[15px] font-medium text-ink/80 hover:text-accent transition-colors" data-id="element-451" data-mp="35e3carfhyf5v">
                  {link.label}
                </Link>
              </li>)}
          </ul>

          <div className="flex items-center gap-3 border-l border-border pl-6" data-id="element-452" data-mp="2qo4j732sttx9">
            <a href="tel:+61386172600" className="flex items-center gap-2 text-sm font-semibold text-ink hover:text-accent transition-colors" data-id="element-453" data-mp="2qm1i9o03ygdr">
              <Phone className="w-4 h-4" data-id="element-454" data-mp="30fifz33d8fmp" />
              (03) 8617 2600
            </a>
            <Button onClick={openQuote} variant="accent" size="sm" data-id="element-455" data-mp="2vlxq5ybxeryl">
              Get a free quote
            </Button>
          </div>
        </nav>

        <div className="flex items-center gap-1.5 lg:hidden" data-id="element-456" data-mp="22z32ksjtbcgw">
          <a href="tel:+61386172600" className="text-ink hover:text-accent p-2.5 min-h-[44px] min-w-[44px] flex items-center justify-center" aria-label="Call L.A Property Law" data-id="element-457" data-mp="22wqqgw0qjwbr">
            <Phone className="w-5 h-5" data-id="element-458" data-mp="9g2wymuy58e5" />
          </a>
          <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-ink p-2.5 min-h-[44px] min-w-[44px] flex items-center justify-center" aria-label={isMobileMenuOpen ? 'Close menu' : 'Open menu'} aria-expanded={isMobileMenuOpen} data-id="element-459" data-mp="9hnoe3lysb7s">
            {isMobileMenuOpen ? <X className="w-6 h-6" data-id="element-460" data-mp="s6ube2tsjoze" /> : <Menu className="w-6 h-6" data-id="element-461" data-mp="s62iizrkw5ct" />}
          </button>
        </div>
      </div>

      <div className={cn('fixed inset-0 bg-background z-30 lg:hidden transition-transform duration-300 ease-soft pt-24 px-6 pb-40 overflow-y-auto', isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full')} data-id="element-462" data-mp="x440fhd9pymp">
        <nav className="flex flex-col gap-6" aria-label="Mobile" data-id="element-463" data-mp="10opv0r0161q">
          <ul className="flex flex-col" data-id="element-464" data-mp="11zt8zgj8bsb">
            {NAV_LINKS.map(link => <li key={link.label} className="border-b border-border" data-id="element-465" data-mp="3sdjeh9a6kxqy">
                <Link to={link.href} className="text-2xl font-serif text-ink block py-4 hover:text-accent transition-colors" data-id="element-466" data-mp="3oeah7ufxmhqn">
                  {link.label}
                </Link>
              </li>)}
          </ul>

          <div className="mt-6 space-y-5" data-id="element-467" data-mp="fww5rovdjlb7">
            <div className="space-y-1.5" data-id="element-468" data-mp="fy7abqwn8x3d">
              <p className="text-xs text-muted-ink uppercase tracking-[0.2em]" data-id="element-469" data-mp="ay2wk8n4eggu">
                Speak with the team
              </p>
              <a href="tel:+61386172600" className="text-2xl font-serif text-ink block" data-id="element-470" data-mp="5ygf1n09ee28">
                (03) 8617 2600
              </a>
              <a href="mailto:hello@lapropertylaw.com.au" className="text-base text-brand-blue block" data-id="element-471" data-mp="2qp7eow7s60pu">
                hello@lapropertylaw.com.au
              </a>
            </div>

            <div className="grid grid-cols-1 gap-3 pt-2" data-id="element-472" data-mp="2ll53rc0lvdfu">
              <Button onClick={() => {
              openUpload();
              setIsMobileMenuOpen(false);
            }} variant="accent" fullWidth size="lg" data-id="element-473" data-mp="2qj6mtwy17crb">
                <FileText className="w-5 h-5" data-id="element-474" data-mp="2ze4g5553crj6" />
                Upload a contract
              </Button>
              <Button onClick={() => {
              openQuote();
              setIsMobileMenuOpen(false);
            }} variant="outline" fullWidth size="lg" data-id="element-475" data-mp="34d7ksoh5svqm">
                Get a free quote
              </Button>
            </div>
          </div>
        </nav>
      </div>
    </header>;
}